namespace TabAurous.Retail {
    export interface POSOrderRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        PartyId?: number;
        POSCustomerId?: number;
        FirstName?: string;
        LastName?: string;
        PosCustomerCode?: string;
        CustomerName?: string;
        PanNumber?: string;
        Email?: string;
        BirthDate?: string;
        Anniversary?: string;
        Address?: string;
        Mobile?: string;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        ReceiptAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        ItemDetails?: POSOrderItemsRow[];
        AddressDetails?: POSOrderAddressRow[];
        ReceiptDetails?: ReceiptDetailsRow[];
        ECommOrderId?: number;
        ECommOrderNo?: string;
        ReasonId?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        CheckList?: ECommerce.OrderManagementCheckListRow[];
        OrderStatusId?: number;
        OrderStatusName?: string;
        ProductItemImage?: string;
        BillingCityName?: string;
        BillingCity?: number;
        BillingState?: number;
        BillingStateName?: string;
        BillingCountry?: number;
        BillingCountryName?: string;
        BillingAddress?: string;
        BillingPin?: string;
        ShippingAddress?: string;
        ShippingCity?: number;
        ShippingCityName?: string;
        ShippingState?: number;
        ShippingStateName?: string;
        ShippingCountry?: number;
        ShippingCountryName?: string;
        ShippingPincode?: string;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        MF?: number;
        Username?: string;
    }

    export namespace POSOrderRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Retail.POSOrder';
        export const deletePermission = 'Retail:POSOrders:Delete';
        export const insertPermission = 'Retail:POSOrders:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:POSOrders:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            PartyId = "PartyId",
            POSCustomerId = "POSCustomerId",
            FirstName = "FirstName",
            LastName = "LastName",
            PosCustomerCode = "PosCustomerCode",
            CustomerName = "CustomerName",
            PanNumber = "PanNumber",
            Email = "Email",
            BirthDate = "BirthDate",
            Anniversary = "Anniversary",
            Address = "Address",
            Mobile = "Mobile",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            ReceiptAmount = "ReceiptAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            ItemDetails = "ItemDetails",
            AddressDetails = "AddressDetails",
            ReceiptDetails = "ReceiptDetails",
            ECommOrderId = "ECommOrderId",
            ECommOrderNo = "ECommOrderNo",
            ReasonId = "ReasonId",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            CheckList = "CheckList",
            OrderStatusId = "OrderStatusId",
            OrderStatusName = "OrderStatusName",
            ProductItemImage = "ProductItemImage",
            BillingCityName = "BillingCityName",
            BillingCity = "BillingCity",
            BillingState = "BillingState",
            BillingStateName = "BillingStateName",
            BillingCountry = "BillingCountry",
            BillingCountryName = "BillingCountryName",
            BillingAddress = "BillingAddress",
            BillingPin = "BillingPin",
            ShippingAddress = "ShippingAddress",
            ShippingCity = "ShippingCity",
            ShippingCityName = "ShippingCityName",
            ShippingState = "ShippingState",
            ShippingStateName = "ShippingStateName",
            ShippingCountry = "ShippingCountry",
            ShippingCountryName = "ShippingCountryName",
            ShippingPincode = "ShippingPincode",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            MF = "MF",
            Username = "Username"
        }
    }
}
